import { apiPost } from '../api';
import { unwrapData } from '@wapharma/shared';;

export async function requestPasswordReset(
  email: string,
): Promise<{ ok: boolean; throttled?: boolean }> {
  const raw = await apiPost<{ data: { ok: boolean; throttled?: boolean } }>(
    '/auth/password-reset-request',
    { email: email.trim().toLowerCase() },
  );
  return unwrapData(raw);
}

export async function validatePasswordResetToken(token: string): Promise<{ ok: boolean }> {
  const raw = await apiPost<{ data: { ok: boolean } }>('/auth/password-reset-validate', { token });
  return unwrapData(raw);
}

export async function resetPassword(token: string, newPassword: string): Promise<{ ok: boolean }> {
  const raw = await apiPost<{ data: { ok: boolean } }>('/auth/password-reset', {
    token,
    newPassword: newPassword.trim(),
  });
  return unwrapData(raw);
}
